import React from 'react';
import PropTypes from 'prop-types';
import css from './StudentNote.css';
import Title from 'common/Title';

export default class StudentNote extends React.Component {
  render() {
    return (
      <div>
        <Title text="Student Note" />
        <div className={css['text']}>
          {this.props.studentNote}
        </div>
      </div>
    );
  }
}

StudentNote.propTypes = {
  studentNote: PropTypes.string.isRequired
};
